import { useMemo } from 'react';
import moment from 'moment';
import BinIcon from '../icon/Icon';
import { TimerBadgeStyled } from './styled/TimerBadgeStyled';

interface ITimerBadgeProps {
    secondsLeft: number,
}

function TimerBadge(props: ITimerBadgeProps) {
    const { secondsLeft } = props;

    const time = useMemo(() => {
        const duration = moment.duration(secondsLeft, 'seconds');
        return moment.utc(duration.asMilliseconds()).format('HH[h] mm[m] ss[s]');
    }, [secondsLeft]);

    return <TimerBadgeStyled>
        <BinIcon name="IcStopwatch" />
        <span>{time}</span>
    </TimerBadgeStyled>;
}

export default TimerBadge;
